import { render, staticRenderFns } from "./tablink.vue?vue&type=template&id=449d8d29"
import script from "./tablink.vue?vue&type=script&lang=js"
export * from "./tablink.vue?vue&type=script&lang=js"
import style0 from "./tablink.vue?vue&type=style&index=0&id=449d8d29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports